import defaults from '@mailobj-browser/front/js/selectors/defaults.js'
import object from '@mailobj-browser/front/js/utils/object.js'

export default () => {
  const { window } = defaults
  const { app } = window
  return object(null, app)
}

export const update = (key, value) => {
  const { window } = defaults
  const { app } = window
  app[key] = value
}
